import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=073cb5dd&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
import style0 from "./Button.vue?vue&type=style&index=0&id=073cb5dd&prod&lang=scss"
import style1 from "./Button.vue?vue&type=style&index=1&id=073cb5dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073cb5dd",
  null
  
)

export default component.exports